import { createContext, useState, type ReactNode } from 'react'
import { Accordion } from '~/shadcn/ui/accordion'

type AccordionContextType = {
  openSectionId: string | null
  toggleSection: (sectionId: string) => void
  isCollapsed: (sectionId: string) => boolean
  value: string | undefined
  onValueChange: (value: string | undefined) => void
}

const AccordionContext = createContext<AccordionContextType | undefined>(
  undefined
)

function AccordionProvider({
  children,
  defaultValue = 'description',
}: {
  children: ReactNode
  defaultValue?: string
}) {
  const [value, setValue] = useState<string | undefined>(defaultValue)

  const toggleSection = (sectionId: string) => {
    setValue((current) => (current === sectionId ? undefined : sectionId))
  }

  const isCollapsed = (sectionId: string) => value !== sectionId
  const openSectionId = value ?? null

  return (
    <AccordionContext.Provider
      value={{
        openSectionId,
        toggleSection,
        isCollapsed,
        value,
        onValueChange: setValue,
      }}>
      <Accordion
        type="single"
        value={value}
        onValueChange={setValue}
        collapsible>
        {children}
      </Accordion>
    </AccordionContext.Provider>
  )
}

export { AccordionContext, AccordionProvider }
